import { useState, useEffect } from "react";
import { FDWResultEntry } from "../../../restfd2/fdw_result";
import { useStore } from "../state/state";
import Checkbox from "./checkbox";
import { FundingsListAccordion } from "./fundings_list_accordion";
import { Tab } from "./tab";
import { H, ViewCopy } from "./view";

export function FundingsList(){
    const [active_tab, set_active_tab] = useState<"zuschusse" | "darlehen">("zuschusse");
    //const [select_all, set_select_all] = useState([]); 
    const include_in_print = useStore((state) => state.include_in_print);
    const set_include_in_print = useStore((state) => state.set_include_in_print);
    const fundings_list = useStore((state) => state.fundings_list);
    const questionizer_login = useStore((state) => state.questionizer_login);
    const questionizer_request_fundings = useStore((state) => state.questionizer_request_fundings);
    const questionizer_request_gid = useStore((state) => state.questionizer_request_gid);

    useEffect(()=>{
      async function load(){
        await questionizer_login();
        await questionizer_request_gid();
        await questionizer_request_fundings();
      }
      load();
    },[]);
    

    type SortedResultsList = Record<string,{region: string, list: Array<FDWResultEntry>}>;

    if (fundings_list == undefined){
      return <div></div>
    }
  
    const zuschuesse = fundings_list.filter((entry) => entry.fp_type == "Zuschuss").reduce((acc: SortedResultsList, entry : FDWResultEntry)=>{
      if (!acc[entry.region]){
        acc[entry.region] = {region:entry.region, list: [entry]}; 
      }else{
        acc[entry.region].list.push(entry);
      }
      return acc;
    },{});

    const darlehen = fundings_list.filter((entry) => entry.fp_type == "Darlehen").reduce((acc : SortedResultsList, entry : FDWResultEntry)=>{
      if (!acc[entry.region]){
        acc[entry.region] = {region:entry.region, list: [entry]}; 
      }else{
        acc[entry.region].list.push(entry);
      }
      return acc;
    },{});

    let zuschuesse_length = Object.keys(zuschuesse).flatMap(key => zuschuesse[key].list).length;
    let darlehen_length = Object.keys(darlehen).flatMap(key => darlehen[key].list).length;

    if (zuschuesse_length + darlehen_length == 0){
      return <></>
    }

    const all_items_selected = () => {
      if (active_tab == "darlehen"){
        return fundings_list.filter((entry) => entry.fp_type == "Darlehen").every((d) => include_in_print[d.fp_id] ?? false);
      } else {
        return fundings_list.filter((entry) => entry.fp_type == "Zuschuss").every((d) => include_in_print[d.fp_id] ?? false);
      }
    }

    const select_all_items = (value: boolean) => {
      if (active_tab == "darlehen"){
         fundings_list.filter((entry) => entry.fp_type == "Darlehen").forEach((f) => {
            set_include_in_print(Number(f.fp_id), value);
          }); 
      } else {
          console.log("alles auswählen", fundings_list.filter((entry) => entry.fp_type == "Zuschuss"));

         fundings_list.filter((entry) => entry.fp_type == "Zuschuss").forEach((f) => {
            console.log(f.fp_id);
            set_include_in_print(Number(f.fp_id), value);
          });
      }
    }

    return <>
      <ViewCopy><H>Passende Förderprogramme</H></ViewCopy>
      <div  className="tabs">
        <div role="tablist" className="tabs__header">
          <Tab id="zuschusse_tab" panel_id="zuschusse_panel" label="Zuschüsse" value="zuschusse" count={zuschuesse_length} active_tab={active_tab} set_active_tab={set_active_tab}/>
          <Tab id="darlehen_tab"  panel_id="darlehen_panel" label="Darlehen" value="darlehen" count={darlehen_length} active_tab={active_tab} set_active_tab={set_active_tab}/>
        </div>
      
        <div className="tabs__header-b"> 
          <Checkbox value={all_items_selected()} 
          onChange={(value)=>{
           select_all_items(value);
          }}/>
          <p className="mt-[0.5rem]">alle auswählen</p>
        </div>
      
        <div className="tabs__body">
          <FundingsListAccordion id="zuschusse_panel" tab_id="zuschusse_tab" active={active_tab == "zuschusse"}  regions={zuschuesse} />
          <FundingsListAccordion id="darlehen_panel" tab_id="darlehen_tab" active={active_tab == "darlehen"} regions={darlehen} />
        </div>
      </div>
    </>;  
  }